import { render, staticRenderFns } from "./LDropBtn.vue?vue&type=template&id=1e8660ae&scoped=true"
import script from "./LDropBtn.vue?vue&type=script&lang=js"
export * from "./LDropBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8660ae",
  null
  
)

export default component.exports